
/**
 * 处理元，最多展示一位小数
 * 如果没有小数，就直接返回整数
 * @param yuan 金额（元）
 * @returns 格式化后的字符串
 */
export const formatYuan = (yuan: number) => {
  const yuanNumber = Number(yuan);
  if (Number.isNaN(yuanNumber) || yuanNumber < 0) {
    return '0';
  }

  const integerPart = Math.floor(yuanNumber);
  const decimalPart = yuanNumber - integerPart;

  // 如果有小数，展示一位小数
  if (decimalPart > 0) {
    return yuanNumber.toFixed(1);
  }

  // 没有小数，直接返回整数
  return String(integerPart);
}

/**
 * 分转元，保留一位小数
 * @param fen 分
 * @returns 
 */
export const getYuanFromFen = (fen: number) => {
  const fenNumber = Number(fen);
  if (Number.isNaN(fenNumber) || fenNumber < 0) {
    return '0';
  }

  const yuan = fenNumber / 100;
  const integerPart = Math.floor(yuan);
  const decimalPart = yuan - integerPart;
  
  // 整数部分超过99的只显示整数
  if (integerPart > 99) {
    return String(integerPart);
  }
  
  // 整数部分小于等于99的如果有小数，展示一位小数
  if (decimalPart > 0) {
    return yuan.toFixed(1);
  }
  
  // 没有小数，直接返回整数
  return String(integerPart);
}